import React from 'react';
import { Icon } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import __ from "lodash";

const styles = (theme) => ({
  flightSeparator: {
    color:theme.palette.primary.main, 
    fontSize: 10,
    paddingLeft: 2,
    paddingRight: 2,
  },
});

const BuildFlightListFromLegs = (props) => {
  const  classes = props.classes;
  const primaryLegs = __.filter(props.legs, {transportType: 'PRIMARY'});
  const flights = [];
  if (primaryLegs.length > 0) {
    primaryLegs.forEach(leg => {
      const flightNumber = `${leg.airlineCode}${leg.flightNo}`;
      if (__.findIndex(flights, flightNumber) < 0) {
        flights.push(flightNumber);
      }
    });
  }
  return (<>{flights.map((flightNumber, i) => (<>{i>0?<Icon className={classes.flightSeparator}>circle</Icon>:<></>}<span>{flightNumber}</span></>))}</>);
}

export default withStyles(styles) (BuildFlightListFromLegs);